import { BiShieldQuarter } from "react-icons/bi";
import { FaCheckSquare } from "react-icons/fa";
import { PiCertificateBold } from "react-icons/pi";
import { AiOutlineBarcode } from "react-icons/ai";
import { GrUserPolice } from "react-icons/gr";
import { GiLighthouse } from "react-icons/gi";
import { PiListBulletsFill } from "react-icons/pi";
import { MdOutlineDocumentScanner, MdRawOn } from "react-icons/md";
import { PiMedalFill } from "react-icons/pi";
import { BsBoxSeamFill } from "react-icons/bs";
import { FaChartPie } from "react-icons/fa";
import { IoBusiness, IoDocuments } from "react-icons/io5";
import { MdVerified } from "react-icons/md";
import { FaBalanceScale } from "react-icons/fa";
import { FaPersonChalkboard } from "react-icons/fa6";

import halalLogo from "../../assets/halal_logo.webp";

import img1_sm from "../../assets/service/img1_sm.webp";
import img2_sm from "../../assets/service/img2_sm.webp";
import img3_sm from "../../assets/service/img3_sm.webp";
import img4_sm from "../../assets/service/img4_sm.webp";
import img5_sm from "../../assets/service/img5_sm.webp";
import { HiReceiptTax } from "react-icons/hi";
import { CgWebsite } from "react-icons/cg";
export const services = [
  {
    mainName: "Food & Consumer Products ",
    mainImg: img1_sm,
    services: [
      {
        id: "1",
        icon: AiOutlineBarcode,
        name: "Product Registration",
        information: "",
      },

      {
        id: "2",
        icon: BiShieldQuarter,
        name: "Regulatory Services",
        information: "",
      },

      {
        id: "3",
        icon: PiCertificateBold,
        name: "Certification Support",
        information: "",
      },
      {
        id: "4",
        icon: BsBoxSeamFill,
        name: "Product Safety Implementation",
        information: "",
      },
    ],
  },
  {
    mainName: "Conformity Assessment",
    mainImg: img2_sm,

    services: [
      {
        id: "5",
        icon: FaChartPie,
        iconColor: "",
        name: (
          <>
            Gap <br /> Analysis
          </>
        ),
        information: "",
      },
      {
        id: "6",
        icon: IoDocuments,
        iconColor: "",
        name: "Documentation Support",
        information: "",
      },

      {
        id: "7",
        icon: MdVerified,
        iconColor: "",
        name: "Accreditation Support",
        information: "",
      },
      {
        id: "8",
        icon: FaCheckSquare,
        name: "Quality Management",
        information: "",
      },
    ],
  },

  {
    mainName: "Trainings",
    mainImg: img4_sm,

    services: [
      {
        id: "9",
        img: halalLogo,
        name: "Halal & Food Safety Training",
        information: "",
      },
      {
        id: "10",
        icon: PiMedalFill,
        name: "Quality And Standardization Training",
        information: "",
      },
      {
        id: "11",
        icon: FaBalanceScale,
        name: "Conformity Assessment Training",
        information: "",
      },
      {
        id: "12",
        icon: FaPersonChalkboard,
        name: "Customized Training",
        information: "",
      },
    ],
  },
  {
    mainName: "Sourcing",
    mainImg: img3_sm,

    services: [
      {
        id: "13",
        icon: MdRawOn,
        name: "Ingredients & Additives",
        information: "",
      },
      {
        id: "14",
        icon: PiListBulletsFill,
        name: "Machinary And Instrumentation",
        information: "",
      },
      {
        id: "15",
        icon: GiLighthouse,
        name: "Logistics Support",
        information: "",
      },
      {
        id: "16",
        icon: GrUserPolice,
        name: "Custom Clearance",
        information: "",
      },
    ],
  },
  {
    mainName: "Business Services",
    mainImg: img5_sm,

    services: [
      {
        id: "17",
        icon: IoBusiness ,
        name: "Business Setup",
        information: "",
      },
      {
        id: "18",
        icon: HiReceiptTax ,
        name: "Tax Registration",
        information: "",
      },
      {
        id: "19",
        icon: CgWebsite ,
        name: "Business Website",
        information: "",
      },
      {
        id: "20",
        icon: MdOutlineDocumentScanner ,
        name: "Business Documentation",
        information: "",
      },
    ],
  },
];
